var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoins(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 10.8936C26 13.1027 21.0751 14.8936 15 14.8936C8.92487 14.8936 4 13.1027 4 10.8936M26 10.8936C26 8.68442 21.0751 6.89355 15 6.89355C8.92487 6.89355 4 8.68442 4 10.8936M26 10.8936V19.8079C23.557 20.5415 22 21.6514 22 22.8936M4 10.8936V34.8936C4 37.1027 8.92487 38.8936 15 38.8936C17.6593 38.8936 20.0981 38.5504 22 37.9793V22.8936M4 18.8936C4 21.1027 8.92487 22.8936 15 22.8936C17.6593 22.8936 20.0981 22.5504 22 21.9793M4 26.8936C4 29.1027 8.92487 30.8936 15 30.8936C17.6593 30.8936 20.0981 30.5504 22 29.9793M44 22.8936C44 25.1027 39.0751 26.8936 33 26.8936C26.9249 26.8936 22 25.1027 22 22.8936M44 22.8936C44 20.6844 39.0751 18.8936 33 18.8936C26.9249 18.8936 22 20.6844 22 22.8936M44 22.8936V38.8936C44 41.1027 39.0751 42.8936 33 42.8936C26.9249 42.8936 22 41.1027 22 38.8936V22.8936M44 30.8936C44 33.1027 39.0751 34.8936 33 34.8936C26.9249 34.8936 22 33.1027 22 30.8936",
    stroke: "black",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoins);
export default __webpack_public_path__ + "static/media/coins.d19df18c34da8bf46d297a0f6dfc0fc9.svg";
export { ForwardRef as ReactComponent };